import React from "react";
import SearchSelect, {
  SearchSelectOption,
} from "@components/FormsV2/SearchSelect";
import useProjectResourceOptions from "./useProjectResourceOptions";

interface ProjectResourceSelectProps {
  id: string;
  label: string;
  hideLabel?: boolean;
  projectId: string;
  // A typed value ("project-resources-1"), or an option, which is shown as
  // given even when it isn't in the list (e.g. an inactive resource).
  value: string | SearchSelectOption | null | undefined;
  onChange: (option: SearchSelectOption | null) => void;
  isDisabled?: boolean;
  isClearable?: boolean;
  className?: string;
}

/**
 * The resource select for project UI: project resources, vendor resources and
 * standard resources (or the rate table's resource rates), named as the
 * project editor names them.
 */
const ProjectResourceSelect = ({
  projectId,
  value,
  ...props
}: ProjectResourceSelectProps): JSX.Element => {
  const { options, isLoading } = useProjectResourceOptions(projectId);
  const selected =
    typeof value === "string"
      ? options.flatMap((g) => g.options).find((o) => o.value === value) ?? null
      : value ?? null;

  return (
    <SearchSelect
      {...props}
      options={options}
      isLoading={isLoading}
      value={selected}
    />
  );
};

export default ProjectResourceSelect;
